import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { ProgressBarModule } from "../progress-bar/progress-bar.module";

import { CountdownProgressBarContainer } from "./countdown-progress-bar.container";

const DIRECTIVES: any[] = [CountdownProgressBarContainer];

@NgModule({
	imports: [CommonModule, GlobalUiModule, ProgressBarModule],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
})
export class CountdownProgressBarModule {}
